import { render } from "./HeroiconsSolidCurrencyDollar.vue?vue&type=template&id=0809505a"
const script = {}

import exportComponent from "/var/app/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidCurrencyDollar.vue"]])

export default __exports__